document.addEventListener('DOMContentLoaded', () => {
    const feedbackButton = document.getElementById('feedbackButton');
    const feedbackPopup = document.getElementById('feedbackPopup');
    const closePopup = document.getElementById('closePopup');
    const feedbackForm = document.getElementById('feedbackForm');

    // Show popup when feedback button is clicked
    feedbackButton.addEventListener('click', () => {
        feedbackPopup.classList.add('active');
    });

    // Close popup when close button is clicked
    closePopup.addEventListener('click', () => {
        feedbackPopup.classList.remove('active');
    });

    // Close popup when clicking outside
    feedbackPopup.addEventListener('click', (e) => {
        if (e.target === feedbackPopup) {
            feedbackPopup.classList.remove('active');
        }
    });

    // Handle form submission
    feedbackForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const feedbackType = document.getElementById('feedbackType').value;
        const feedbackText = document.getElementById('feedbackText').value;
        const userEmail = document.getElementById('userEmail').value;
        const submitButton = feedbackForm.querySelector('.submit-button');

        // Google Form entry IDs
        const formData = new FormData();
        formData.append('entry.1572135147', feedbackType);
        formData.append('entry.429968500', userEmail);
        formData.append('entry.1456108273', feedbackText);
        try {
            const response = await fetch('https://docs.google.com/forms/d/e/1FAIpQLSeKFRjGZJzJEmzjZ7C_BdGZ0IW5wFoW7sZo-JA9DfurFCGvDw/formResponse', {
                method: 'POST',
                body: formData,
                mode: 'no-cors'
            });

            // Show success state
            submitButton.textContent = 'Thank you!';
            submitButton.disabled = true;
            feedbackForm.reset();

            // Reset button and close popup after 2 seconds
            setTimeout(() => {
                submitButton.textContent = 'Submit Feedback';
                submitButton.disabled = false;
                feedbackPopup.classList.remove('active');
            }, 800);
        } catch (error) {
            console.error('Error submitting feedback:', error);
            submitButton.textContent = 'Error - Try Again';
            setTimeout(() => {
                submitButton.textContent = 'Submit Feedback';
            }, 2000);
        }
    });
}); 